/**
 * Shared layout dimensions for the fixed site chrome (header + early-preview
 * banner). These are the single source of truth for any element that needs to
 * offset itself below the fixed header — layout shells, sticky sub-headers, etc.
 *
 * Keep these in sync with the corresponding Tailwind classes in
 * `Header.tsx` (`h-24`, `top-[36px]`) and `EarlyPreviewBanner.tsx` (`py-2`).
 */

/** Height of the fixed site header in pixels (matches `h-24` in Header.tsx). */
export const HEADER_HEIGHT = 96;

/** Height of the early-preview banner in pixels (matches `top-[36px]` in Header.tsx). */
export const EARLY_PREVIEW_BANNER_HEIGHT = 36;

/**
 * Total vertical space occupied by the fixed chrome, accounting for whether the
 * early-preview banner is currently visible. Use this for `paddingTop` on layout
 * shells and `top` on elements that stick directly beneath the header.
 */
export function getFixedChromeOffset(isBannerVisible: boolean): number {
  return isBannerVisible ? HEADER_HEIGHT + EARLY_PREVIEW_BANNER_HEIGHT : HEADER_HEIGHT;
}
